import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../../authConfig';
import ActionButton from '../../Base/ActionButton/action-button';
import Loader from '../../Base/Loader/Loader';
import { useScreenDetection } from '../../../../common/helpers/screen-detection';

export interface AuthenticationProps {
	isLoading: boolean;
}

/**
 * Renders a simple button that loads a popup for signing in.
 */
export default function SignInButton({ isLoading }: AuthenticationProps) {
	const { instance } = useMsal();
	const { screenInfo } = useScreenDetection();

	const loginRedirect = () => {
		instance.loginRedirect(loginRequest);
	};

	const handleLogin = () => {
		loginRedirect();
	};

	useEffect(() => {
		instance.handleRedirectPromise().then((response) => {
			if (response !== null) {

			}
		});
	}, []);

	return (
		<ActionButton secondary largeFont={screenInfo.isMobile} onClick={() => handleLogin()}>
			{isLoading && <Loader simple size={'sm'} />}
			{!isLoading && `Sign In`}
		</ActionButton>
	);
}
